/**
 * 品牌 API — 列表 + AI可见性 + 引用分析。
 */
import client from "./client";
import type { Brand, AiVisibility, CitationAnalysis } from "../types";

/** 获取品牌列表（可按公司筛选）。 */
export async function getBrands(companyId?: string): Promise<Brand[]> {
  return client.get<unknown, Brand[]>("/brands", {
    params: companyId ? { company_id: companyId } : undefined,
  });
}

/** 获取品牌详情。 */
export async function getBrand(brandId: string): Promise<Brand> {
  return client.get<unknown, Brand>(`/brands/${brandId}`);
}

/** 获取品牌 AI 可见性数据。 */
export async function getBrandAiVisibility(
  brandId: string,
): Promise<AiVisibility[]> {
  return client.get<unknown, AiVisibility[]>(
    `/brands/${brandId}/ai-visibility`,
  );
}

/** 获取品牌引用分析数据。 */
export async function getBrandCitations(
  brandId: string,
): Promise<CitationAnalysis[]> {
  return client.get<unknown, CitationAnalysis[]>(
    `/brands/${brandId}/citation-analysis`,
  );
}
